import { IAppointment } from '@pia/pia.shared';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { AppointmentDB } from 'src/app/common/repository/databases';
import { QueryService } from 'src/app/shared/services/query/query.service';

@Injectable()
export class AppointmentResolver implements Resolve<IAppointment> {
  constructor(private queryService: QueryService) {}

  resolve(route: ActivatedRouteSnapshot): Promise<IAppointment> {
    return this.queryService.get(route.paramMap.get('appointmentId'), AppointmentDB);
  }
}
